import { Core } from "@faire/design-tokens";
import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { VIEWPORT } from "@faire/help-center-utils/consts/eventEnum";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHelpCenterHeaderSwitcherClick } from "@faire/web-api--source/events/helpCenter/click/headerSwitcher";
import { StringContextType } from "@faire/web-api--source/faire/translator/StringContextType";
import brands from "@faire/web-api--source/routes/support/brands";
import retailers from "@faire/web-api--source/routes/support/retailers";
import React from "react";
import styled from "styled-components";

export const Menu: React.FC = () => {
  const retailerToken = getRetailerToken() ?? "";
  const brandToken = getBrandToken() ?? "";
  const { isMobile } = useViewport();

  const handleSwitchClick = (customerType: CustomerTypes) => {
    trackHelpCenterHeaderSwitcherClick(
      retailerToken,
      brandToken,
      isMobile ? VIEWPORT.WEB_MOBILE : VIEWPORT.WEB_DESKTOP,
      customerType
    );
  };

  return (
    <MenuWrapper>
      <ButtonWithoutDecoration
        variant="tertiary"
        linkTo={retailers()}
        onClick={() => handleSwitchClick(CustomerTypes.RETAILER)}
      >
        <StrictLocalMsg
          defaultMessage="for Retailers"
          description={{
            text: "This is the change button in the header",
            stringDescriptors: [StringContextType.CALL_TO_ACTION],
          }}
        />
      </ButtonWithoutDecoration>
      <Spacer height="2x" />
      <ButtonWithoutDecoration
        variant="tertiary"
        linkTo={brands()}
        onClick={() => handleSwitchClick(CustomerTypes.BRAND)}
      >
        <Typography>
          <StrictLocalMsg
            defaultMessage="for Brands"
            description={{
              text: "This is the change button in the header",
              stringDescriptors: [StringContextType.CALL_TO_ACTION],
            }}
          />
        </Typography>
      </ButtonWithoutDecoration>
    </MenuWrapper>
  );
};

const MenuWrapper = styled(Column).attrs({
  justify: "space-between",
  align: "start",
})`
  position: absolute;
  background-color: ${Core.surface.inverse};
  z-index: 2;
  padding: ${getSpacing("3x", "4x")};
  border: 1px solid ${Core.border.muted};
  top: 45px;
  ${responsiveMediaQueries.mobile} {
    right: 0;
    width: 200px;
  }
  ${responsiveMediaQueries.tabletAndAbove} {
    right: -50%;
    width: 240px;
  }
`;

const ButtonWithoutDecoration = styled(Button)`
  text-decoration: none;
`;
